/**
 * The three button fills, shared by `Button` and by the one-off controls that
 * cannot use it (icon buttons, segmented controls, table actions).
 *
 * Every weight is a solid fill: outlined buttons read as too faint against the
 * paper surfaces, so hierarchy comes from the fill colour, not from a border.
 */
export const filledFill = 'bg-btn-filled-bg text-btn-filled-text hover:bg-btn-filled-hover-bg'
export const softFill = 'bg-btn-soft-bg text-btn-soft-text hover:bg-btn-soft-hover-bg'
export const quietFill = 'bg-btn-quiet-bg text-btn-quiet-text hover:bg-btn-quiet-hover-bg'

export const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2'

/** Disabled treatment shared by every button weight. */
export const disabledFill = 'disabled:opacity-40 disabled:cursor-not-allowed'

/**
 * Segmented controls and radiogroups: both states are filled, so the resting
 * option still reads as a pressable surface rather than an empty outline.
 */
export const segmentedSelected = filledFill
export const segmentedRest = quietFill

/**
 * Icon buttons (theme toggle, text size, reader settings).
 *
 * Transparent at rest. A permanent filled disc behind each glyph put two heavy grey
 * circles in a nav whose every other item is light mono text — the buttons shouted
 * louder than the links they sat beside. The hover fill and the focus ring carry the
 * affordance instead, and a button whose popover is open adds `filledFill` so the
 * open state still reads at a glance.
 */
export const iconFill =
  'inline-flex items-center justify-center min-h-11 min-w-11 w-11 h-11 rounded-full transition-colors duration-200 ' +
  'text-nav-toggle hover:text-nav-toggle-hover hover:bg-btn-quiet-bg ' + focusRing
